import { Business } from "../api/business";

// Mirrors the backend's BenefitDto.IsActive: now > start && (end == null || now < end).
// A missing or unparseable start counts as not started; an unparseable end counts as open-ended.
export const isMerchantInactive = (
  merchant: Pick<Business, "benefits">,
  now: Date = new Date()
): boolean => {
  const benefits = merchant.benefits ?? [];

  return !benefits.some((benefit) => {
    if (!benefit?.startDateTime) return false;

    const start = new Date(benefit.startDateTime).getTime();
    if (Number.isNaN(start) || now.getTime() <= start) return false;

    if (!benefit.endDateTime) return true;

    const end = new Date(benefit.endDateTime).getTime();
    return Number.isNaN(end) ? true : now.getTime() < end;
  });
};

// Merchants whose benefit has expired stay selectable so their transactions can still be looked up,
// so the label has to say which ones are no longer running.
export const merchantLabel = (
  merchant: Pick<Business, "name" | "benefits">,
  now: Date = new Date()
): string =>
  isMerchantInactive(merchant, now) ? `${merchant.name} (inactive)` : merchant.name;
